import React from 'react';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#F4F2EE] py-24 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-180">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-181">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-182">
          <div className="w-24 h-24 bg-white border border-[#EAE6E1] rounded-full flex items-center justify-center mx-auto mb-10 shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-183">
            <span className="text-5xl" data-id="element-184">🛡️</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330] mb-8" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-185">
            Garantía 7 Días — Sin Preguntas
          </h2>

          <div className="space-y-4 text-[#4A5568] text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-186">
            <p data-id="element-187">Abrís los tomos. Los usás en tu práctica.</p>
            <p data-id="element-188">
              Si en 7 días sentís que esta formación no es para vos, te
              devolvemos el 100% de tu dinero. Sin formularios complicados. Sin
              drama.
            </p>
          </div>
        </div>
      </div>
    </section>;
}